import { render, staticRenderFns } from "./PromotionDetailDialog.vue?vue&type=template&id=67c36972&scoped=true"
import script from "./PromotionDetailDialog.vue?vue&type=script&lang=js"
export * from "./PromotionDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetailDialog.vue?vue&type=style&index=0&id=67c36972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c36972",
  null
  
)

export default component.exports